import { useInfiniteQuery } from '@tanstack/react-query';

import { searchAssetsByTypeApi } from '@/entities/asset-search/api/searchAssetsByTypeApi';

type UseInfiniteAssetSearchParams = {
  assetTypes: 'dataset' | 'feature_set' | 'run_parameter_set' | string[];
  query?: string;
  enabled?: boolean;
};

export const useInfiniteAssetSearch = ({ assetTypes, query, enabled = true }: UseInfiniteAssetSearchParams) => {
  return useInfiniteQuery({
    queryKey: ['asset-search', assetTypes, query],
    queryFn: ({ pageParam }) =>
      searchAssetsByTypeApi({
        assetTypes,
        query,
        size: 15,
        sortBy: 'created_at',
        sortOrder: 'desc',
        cursor: pageParam,
      }),
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.nextCursor : undefined),
    initialPageParam: undefined as string | undefined,
    enabled,
  });
};
